import React from 'react';
import { createPortal } from 'react-dom';

import Sidebar from './Sidebar';

let sidebarRoot = document.getElementById('sidebar-root');
if (!sidebarRoot) {
  sidebarRoot = document.createElement('div');
  sidebarRoot.setAttribute('id', 'sidebar-root');
  document.body.appendChild(sidebarRoot);
}

const SidebarPortal = (props) => createPortal(<Sidebar {...props} />, sidebarRoot);

export default SidebarPortal;
